<script setup>
import { onMounted, onBeforeUnmount } from 'vue'
import { useI18n } from 'vue-i18n'
import eventBus from '@core/utils/eventBus.js'
import { showTips } from '@components/popup/tips/index.js'

defineOptions({
  name: 'PayView',
})

const { t } = useI18n()

const showPay = (src) => {
  showTips({
    title: t('pay.iframe.title'),
    text: t('pay.iframe.ready'),
    btnText: t('common.open'),
    btnHref: src,
  })
}

// 支付页面所有地区尽量维护同一份代码
onMounted(() => {
  eventBus.on('pay', showPay)
})

onBeforeUnmount(() => {
  eventBus.off('pay', showPay)
})
</script>

<template></template>
